import React from 'react';
import tw from 'twin.macro';

const SuccessMessage = tw.p`text-green-500 italic whitespace-pre-line`;

export default SuccessMessage;
